import { useEffect, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { fetchConToken } from '../helpers/fetch';

export function useCrmCommercialState({ onSaved }) {
    const [request, setRequest] = useState(null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const pending = useRef(false);
    const begin = (lead, status) => { setError(null); setRequest({ lead, status, operationId: uuid() }); };
    const close = () => { if (!pending.current) setRequest(null); };
    const submit = async ({ reason = '', stageId } = {}) => {
        if (pending.current || !request) return;
        pending.current = true; setSaving(true); setError(null);
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
            const response = await fetchConToken(`crm/${request.lead.id}/commercial-state`, {
                estado_comercial: request.status, expected_version: request.lead.crm_version || 0,
                operation_id: request.operationId, ...(request.status === 'perdida' ? { motivo_perdida: reason } : {}),
                ...(request.status === 'abierta' && stageId ? { id_etapa: stageId } : {}),
            }, 'PATCH', { signal: controller.signal });
            const body = await response.json();
            if (!response.ok || !body.ok) { const failure = new Error(body.msg || 'No se pudo cambiar el estado'); failure.conflict = response.status === 409; throw failure; }
            onSaved(body.data);
            setRequest(null);
        } catch (failure) {
            setError({ message: failure.name === 'AbortError' ? 'El servidor tardó demasiado. Puedes reintentar.' : failure.message, conflict: failure.conflict });
        } finally { clearTimeout(timeout); pending.current = false; setSaving(false); }
    };
    useEffect(() => {
        const warn = event => { if (pending.current) { event.preventDefault(); event.returnValue = ''; } };
        window.addEventListener('beforeunload', warn);
        return () => window.removeEventListener('beforeunload', warn);
    }, []);
    return { request, saving, error, begin, close, submit };
}
